// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 945 ? "dashboard" : chunkId) + "." + {"13":"c0b47023","487":"44d928a3","837":"00cc4b9e","945":"7f899753","985":"80cb1a29"}[chunkId] + ".css";
};